import React from 'react';
import ReactMarkdown from 'react-markdown';
import { MermaidDiagram } from '@/components/MermaidDiagram';

interface DetailsContentProps {
  description?: string;
  flowChart?: string;
}

export const DetailsContent: React.FC<DetailsContentProps> = ({ description, flowChart }) => {
  return (
    <div className="h-full w-full space-y-4 p-4">
      {description && (
        <div className="prose dark:prose-invert max-w-none">
          <ReactMarkdown>{description}</ReactMarkdown>
        </div>
      )}
      {flowChart && (
        <div className="mt-4 flex items-center justify-center">
          <MermaidDiagram chart={flowChart} className="mermaid-diagram w-fit" />
        </div>
      )}
    </div>
  );
};
